import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useTheme,
} from '@chakra-ui/react'
import React, { useRef } from 'react'

export function UnsavedChangesModal({
  isOpen,
  onClose,
  onSaveAndExit,
  onDiscardAndExit,
  isSaving = false,
}) {
  const cancelRef = useRef()
  const theme = useTheme()

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent bg={theme.colors.gray[800]} color="white">
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Unsaved Changes
          </AlertDialogHeader>

          <AlertDialogBody>
            You have unsaved changes. Do you want to save them before
            leaving?
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose} variant="ghost">
              Cancel
            </Button>
            <Button
              onClick={onDiscardAndExit}
              colorScheme="red"
              ml={3}
              isLoading={isSaving}
            >
              Discard & Exit
            </Button>
            <Button
              onClick={onSaveAndExit}
              colorScheme="blue"
              ml={3}
              isLoading={isSaving}
            >
              Save & Exit
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
